import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { theme } from './theme';

interface IAirportInformationProps {
  originCityName: string;
  originAirportCode: string;
  destinationCityName: string;
  destinationAirportCode: string;
}

export const styles = {
  fontWeight: css`
    font-weight: ${theme.fontWeight.black};
  `,
  margin: css`
    margin: 0 ${theme.fontWeight.black};
  `,
  marginRight: css`
    margin-right: ${theme.spacing.md};
  `,
};

export const AirportInformation = ({
  originCityName,
  originAirportCode,
  destinationCityName,
  destinationAirportCode,
}: IAirportInformationProps): ReactElement => {
  return (
    <span>
      {originAirportCode && originCityName && (
        <>
          {originCityName} <b css={styles.fontWeight}>{originAirportCode}</b>
        </>
      )}
      {' - '}
      {destinationCityName && destinationAirportCode && (
        <>
          {destinationCityName} <b css={[styles.fontWeight, styles.marginRight]}>{destinationAirportCode}</b>
        </>
      )}
    </span>
  );
};
